/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1091
 */

var r = require(/* 231 */"../1282/231")
var /* [auto-meaningful-name] */Math$floor = Math.floor
module.exports = function (e) {
  return !r(e) && isFinite(e) && Math$floor(e) === e
}
